(function() {
  var AccessController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.SmsLogController = (function(superClass) {
    extend(SmsLogController, superClass);

    function SmsLogController(scope, transitions, data, window, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.window = window;
      this.http = http;
      SmsLogController.__super__.constructor.call(this, 'sms_log', this.http);
      this.scope.title = 'SMS Log';
      this.scope.fullpage = true;
      this.scope.displayedCollection = [];
      this.loadScopeData(this.data.getSmses(), 'smses').then((function(_this) {
        return function() {
          angular.element(_this.window).trigger('resize');
          return true;
        };
      })(this));
    }

    return SmsLogController;

  })(AccessController);

}).call(this);
